import { CALL_API } from '../middleware/api';

export const LOADED_DIAL_PAD_CHANNELS_SUCCESS = Symbol('LOADED_DIAL_PAD_CHANNELS_SUCCESS');

/** Load channels. */
export function getChannels() {
  return {
    [CALL_API]: {
      method: 'get',
      path: '/api/v1/broadcasting/channels',
      unifier: `get channels /api/v1/broadcasting/channels`,
      successType: LOADED_DIAL_PAD_CHANNELS_SUCCESS,
      skipGlobalErrorHandler: true,
    },
  };
}
